import { render } from "./ListeCommentaires.vue?vue&type=template&id=6fb0470a&scoped=true"
import script from "./ListeCommentaires.vue?vue&type=script&lang=js"
export * from "./ListeCommentaires.vue?vue&type=script&lang=js"

import "./ListeCommentaires.vue?vue&type=style&index=0&id=6fb0470a&lang=scss&scoped=true"

import exportComponent from "/Users/anthony/Documents/APP/SIMEF LAST/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb0470a"]])

export default __exports__